import React, { useState } from 'react';
import './Login.css';
import PasswordInput from '../utils/PasswordInput';
import {  useAuth } from '../../services/context/AuthContext';

const LoginForm = ({ onLogin }) => {

  const [email, setEmail] = useState('');
  const [error, setError ] = useState('');
  const [password, setPassword] = useState('');
  const { login } = useAuth();

  const handlePasswordChange = (value) => {
    setPassword(value);
  };
  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      await login(email, password);
      onLogin();
    } catch (error) {
      setError('Erro durante o login: senha ou email incorretos');
      console.error('Erro durante o login:', error.message);
    }
  };

  return (

      <div className='login-container'>
        <div className='login-header'>
          <h2>Entrar</h2>

        {error && <p style={{ color: "red" }}>{error}</p>}
        </div>
        <form onSubmit={handleLogin}>
          <label>
            Email
            <br></br>
            <input
              type='email'
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </label>
        <label for="">
          <PasswordInput value={password} onChange={handlePasswordChange} />
        </label>
          <button type='submit'>Entrar</button>
        </form>
      </div>
  );
};

export default LoginForm;

